export default "__VITE_ASSET__d166e7ca__"